import { cn } from "@peerigon/pupper/tailwind";
import {
	isHeading,
	isParagraph,
	isRoot,
	isList,
	isListItem,
	isSpan,
} from "datocms-structured-text-utils";
import React from "react";
import { renderNodeRule } from "react-datocms";
import { Hx } from "../Heading/Heading";
import type { Span } from "datocms-structured-text-utils";

export const HeadingRenderer = renderNodeRule(
	isHeading,
	({ node, children, key }) => {
		const level = Math.max(1, Math.min(node.level, 6));

		return (
			<Hx
				data-structured-text-block="heading"
				increment={level - 1}
				key={key}
				autoSize={true}
			>
				{children}
			</Hx>
		);
	},
);

export const ParagraphRenderer = renderNodeRule(
	isParagraph,
	({ children, key }) => {
		return (
			<p data-structured-text-block="paragraph" key={key}>
				{children}
			</p>
		);
	},
);

export const UnorderedListRenderer = renderNodeRule(
	isList,
	({ children, key, ancestors }) => {
		if (ancestors[0] && isRoot(ancestors[0])) {
			return (
				<ul data-structured-text-block="list" className="list-none pl-0 mb-[2em]" key={key}>
					{children}
				</ul>
			);
		}

		return children;
	},
);

export const ListItemRenderer = renderNodeRule(
	isListItem,
	({ node, children, key }) => {
		const hasPlaceholder = node.children.some((child) => {
			if (!isParagraph(child)) return false;

			return child.children.some(
				(span) => isSpan(span) && span.value.includes("{plus}"),
			);
		});

		const iconClass = hasPlaceholder
			? "before:bg-[url('/img/plus.svg')]"
			: "before:bg-[url('/img/checkmark.svg')]";

		return (
			<li
				key={key}
				className={cn(
					"flex mb-[1em] text-sm leading-normal lg:text-base lg:leading-relaxed before:shrink-0 before:content-[''] before:bg-no-repeat before:bg-center before:size-6 before:inline-flex before:mr-2",
					iconClass,
				)}
			>
				{children}
			</li>
		);
	},
);

export const SpanRenderer = renderNodeRule(
	(node): node is Span => isSpan(node) && node.value.includes("{plus}"),
	({ node, key }) => {
		const text = node.value.replace(/{plus}/g, "");

	return <span key={key}>{text}</span>;
});

// 🔬 TBD: Please evaluate
